import * as React from 'react'

import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Column,
  Columns,
  IconButton,
  Text
} from '@espoon-voltti/react-components/elements'

interface CreateAppBtnProps {
  grantPeriodId: string
  label: React.ReactNode
  text: React.ReactNode
  onClick?: () => void
  disabled?: boolean
}

export const CreateAppBtn: React.FC<CreateAppBtnProps> = (p) => (
  <Columns dataQa={`createApp-${p.grantPeriodId}`}>
    <Column>
      <Text align={'right'} display={'block'}>
        {p.label}
      </Text>
      <Text weight={'bold'} align={'right'} display={'block'}>
        {p.text}
      </Text>
    </Column>
    <Column size={'narrow'}>
      <IconButton
        dataQa="newAppBtn"
        size={'large'}
        icon={faPlus}
        primary={true}
        onClick={p.onClick}
        disabled={p.disabled}
        muted={p.disabled}
      />
    </Column>
  </Columns>
)
